import React from "react";
import { TicketData, VenueData, TicketGroupData } from "../types";

interface NewTicketModalProps {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: any) => void;
  isLoading?: boolean;
  ticketKind: "single" | "group";
  hasMultipleVenues?: boolean;
  venues?: VenueData[];
  hasMultipleTicketGroups?: boolean;
  ticketGroups?: TicketGroupData[];
  isTicketFree?: boolean;
  editingTicket?: TicketData;
  type?: boolean;
}

const NewTicketModal: React.FC<NewTicketModalProps> = ({ isOpen, toggle }) => {
  if (!isOpen) return null;
  return (
    <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Ticket Modal</h5>
            <button type="button" className="btn-close" onClick={toggle} />
          </div>
          <div className="modal-body">
            <p>New Ticket Modal Stub</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTicketModal;
